module.exports = "/_next/static/images/Understand-46fe320f2de69d599c6ac7ad8c9bf088.png";